import createStore from "./create-store";
import { getQueryVariable } from "../helpers/get-query-variable.js";
import isTouchDevice from "../helpers/is-touch-device.js";
import {getAudioPreferenceFromLocalstorage} from '../_audio/audio-localstorage-operations'

function getInitialGameArea() {
  //Straight to Online play if specified in URL
  if (getQueryVariable("online")) {
    return "arena";
  }

  //Straight to a quick battle
  if (getQueryVariable("quick")) {
    return "arena";
  }

  //Default to Home
  return "b5-home-screen";

  //"battle", "b5-offline-battle-over", "b5-online-battle-over, "b5-records-screen"
}

function getCreateRoomType() {
  if (getQueryVariable("open")) {
    return "open";
  }

  return "fullteam"; //default.
}

const store = createStore({
  global: {
    audioMode: getAudioPreferenceFromLocalstorage(), //"full" | "off" //TODO: I recently removed "sfx", but functionality is still there.

    //Viewport stuff
    vW: 0,
    viewportWidth: 0,
    viewportHeight: 0,
    //viewportMode: Desktop/Mobile layout. Automatically set by GameFrame.js
    viewportMode: "portrait", //"portrait" or "landscape"

    //TouchMode: NOT FOR desktop/mobile layout! Only knowing if this device requires touch to play.
    isTouchMode: isTouchDevice(),

    //This will eventually include Pause, Overworld, etc in the full game
    gameArea: getInitialGameArea(),

    isHomeEmailModalOpen: false
  },
  battle: {
    battlePlayerId: null, //[] //ARRAY - combatants that are controlled by the player
    //populated by firebase anon auth
    isMultiplayerMode: Boolean(getQueryVariable("online")), // false, //true, //false

    //launch reporting mode if URL has it
    battleViewMode: Boolean(getQueryVariable("reporting"))
      ? "reporting"
      : "arena", //"arena", //"console", "arena", "reporting"

    isMultiplayerMasterClient: false, //starts as false for everybody

    //hasBattleStarted from server
    hasBattleStarted: false, // starts false until all players are connected and ready.

    //"battleState" values from server
    combatantSelectingAction: "", //must be a string of a combatant ID
    seriesTurnOrder: [
      // "a", "c", "b". //Master will set this and send out to all clients.
    ], //Reset on end of every series? Ordered by speed. Yep. this is what Mario RPG does.

    seriesTurnsSubmitters: [], //Always is a copy of seriesTurnOrder, but items get deleted as user goes.

    combatants: {},
    teams: {},

    //"rollout"
    //Rollout. Communicate what it is and if we've seen it.
    hasRolloutBeenSeen: true,
    rolloutId: "initial",
    rolloutData: [],
    rolloutExecutingIndex: 0, //Set and changed by `handle-new-rollout` and `handle-rollout-step`
    lastSeenTextMessage: {
      content: [],
      key: "initial"
    },
    rolloutHistory: [], //Report of everything that has happened (for Reporting and debugging)

    //Cloud Queue
    cloudQueue: [],

    //Arena specific stateful pieces
    arenaSubmissionMenuAction: null, // {}
    //arenaSubmissionMenuCaster: null, // {} //can be computed
    arenaSubmissionMenuTargets: null, //[ {} ]
    arenaSubmissionIsSubmitted: false,

    arenaSubmissionMenuCombatantIdLock: null, //keeps track of receiving and passing off the Submission Menu

    arenaAnimationComponent: null,
    arenaBackgroundStyle: "rgba(0,0,0,0)",

    arenaMenuSnapshot: {},

    arenaTransitionOverlay: null, //{transition: "fadeIn" | "fadeOut", callback: function }

    //arenaTaunt: null, //populated by Firebase
    // arenaTaunt: "Taunter: YOU SUCK!",

    serverRoomConnections: {},

    //Reporting Data
    hpRatingsOfTeamsPerTurnSeries: [], //array of arrays [teamOneHp, teamTwoHp]
    turnReporting: {}, //built by turn-reporting.js

    //Optional settings "ff = Feature Flag"
    ff_IsTeamItemsOn: true,
    ff_IsRejoiningOn: true //Allowing People to rejoin battles after leaving
  },
  matchmaking: {
    initialCombatantData: {}, //Lobby dataset
    crewNames: {},
    readyClients: {},

    isLobbyInviteModalOpen: false,
    isCrewNameModalOption: false,

    userDataState: "Loading", // "Loading", "Success"
    currentRoomId: null,
    currentRoomType: null, //set by joining room
    redirectToRoom: null,

    isDuplicateEntryScreen: false, //Blocks users from connecting to the same room twice

    createRoomType: getCreateRoomType(), //"fullteam" or "open"

    errorMessage: {
      status: "None",
      message: ""
    },

    matchResult: "win", // "unknown" | "win" | "lose"

    //Editing a combatant with the modal.
    // editingCombatantProperties: {
    //   isActivated: true,
    //   editingId: "",
    //   combatantName: "Jerry",
    //   combatantSkin: "skin_f1",
    //   combatantLoadoutId: "dpsA",
    // }
    //default:
    editingCombatantProperties: { isActivated: false }
  },

  crew: {
    name: "Default Crew Name", //populated by b5LoadCrew
    record: {
      //populated by b5LoadCrew
    },
    members: {
      //populated by b5LoadCrew
    },
    logggedInUserId: null //assume not logged in. b5LoadCrew will set this this (also need to set any other time you are logging in)
  }
});

export default store;



// WEBPACK FOOTER //
// ./src/init/store.js